const galleryOfImages = document.getElementById("arlo-singleproject-gallery");
const galleryOfImagesArray = Array.from(
  galleryOfImages.querySelectorAll(".arlo-project-gallery-image")
);
const galleryOverlay = document.getElementById("arlo-gallery-image-overlay");
const galleryOverlayImage = document.getElementById(
  "arlo-gallery-overlay-image"
);
const closeGalleryOverlay = galleryOverlay.querySelector(".close");
const leftArrow = galleryOverlay.querySelector(".arrow.left");
const rightArrow = galleryOverlay.querySelector(".arrow.right");

let currentImageIndex = 0;
let isProjectImageZoomed = false;

// Show overlay when an image is clicked
galleryOfImagesArray.forEach(function (image) {
  image.addEventListener("click", function (event) {
    if (!isProjectImageZoomed) {
      const clickedImage = event.target;
      currentImageIndex = galleryOfImagesArray.indexOf(clickedImage);
      showOverlay(clickedImage.src);
    }
  });
});

// Show overlay with the clicked image
function showOverlay(imageSrc) {
  galleryOverlayImage.src = imageSrc;
  galleryOverlay.classList.remove("hidden");

  // galleryOverlay.style.display = 'flex'; // Make the overlay visible
}

// Navigate to the next image
rightArrow.addEventListener("click", function () {
  currentImageIndex = (currentImageIndex + 1) % galleryOfImagesArray.length;
  galleryOverlayImage.src = galleryOfImagesArray[currentImageIndex].src;
});

// Navigate to the previous image
leftArrow.addEventListener("click", function () {
  currentImageIndex =
    (currentImageIndex - 1 + galleryOfImagesArray.length) %
    galleryOfImagesArray.length;
  galleryOverlayImage.src = galleryOfImagesArray[currentImageIndex].src;
});

// Add a click event listener on the image for zooming in/out
galleryOverlayImage.addEventListener("click", function () {
  if (!isProjectImageZoomed) {
    galleryOverlayImage.classList.add("zoomed");
    isProjectImageZoomed = true;
    console.log(isProjectImageZoomed);
  } else {
    galleryOverlayImage.classList.remove("zoomed");
    isProjectImageZoomed = false;
    console.log(isProjectImageZoomed);
  }
});

// To ensure the zoomed image moves with the mouse when zoomed
galleryOverlayImage.addEventListener("mousemove", function (event) {
  if (isProjectImageZoomed) {
    const rect = galleryOverlayImage.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;
    galleryOverlayImage.style.transformOrigin = `${x}% ${y}%`;
  }
});

// Close the overlay when the escape key is pressed
document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    galleryOverlay.classList.add("hidden");
    galleryOverlayImage.classList.remove("zoomed");
    isProjectImageZoomed = false;
  }
});

// Reset zoom on overlay close
closeGalleryOverlay.addEventListener("click", function () {
  galleryOverlay.classList.add("hidden");
  galleryOverlayImage.classList.remove("zoomed");
  isProjectImageZoomed = false;
  console.log(isProjectImageZoomed);
});

galleryOverlay.addEventListener("click", function (event) {
  // Check if the clicked element is the overlay itself (not the image or any child element)
  if (event.target === galleryOverlay) {
    galleryOverlay.classList.add("hidden");
    galleryOverlayImage.classList.remove("zoomed");
    isProjectImageZoomed = false;
    console.log(isProjectImageZoomed);
  }
});
